import { Directive, Input } from '@angular/core';
import { TicketService } from '@routes/ticket-manager/ticket.service';
import { AuthService } from '@core/auth/auth.service';
import { ApiService } from '@shared/apis';
import { EventService } from '@shared/services/event.service';
import { TicketManager } from '@routes/ticket-manager';
import { SpinnerService } from '@shared/services/spinner.service';
import { takeWhile } from 'rxjs/operators';
import { Step } from '@shared/models/step';
import { FormBuilder } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import Configs from '@shared/constants/configs';
import ContentSteps from '@routes/tickets/ticket-edit/contents/contents-steps';
import { TicketInfo } from '@shared/models/ticket-info';
import { Ticket } from '@routes/ticket-manager/ticket';
import { HttpClient } from '@angular/common/http';
import { Constants } from '@shared/constants/constants';
import { environment } from '@env/environment';
import Roles from '@shared/constants/roles';
import { FileService } from '@shared/services/file.service';
import Role from '@shared/constants/role';

@Directive()
export class ContentsBase {
  @Input() data: Step;

  /*  protected SERVICE_CODE = {
      PICKUP_SERVICE: 'PS',
      DEMO_SERVICE: 'DM',
      IN_HOME: 'IH',
      STOCK_REPAIR: 'SR',
    };

    protected CUSTOMER_TYPE = {
      CUSTOMER: 'Customer',
      STORE: 'Store',
    };*/

  public OUT_OF_WARRANTY = 'OW';

  readonly configs = Configs;
  readonly constants = Constants;
  readonly color = Configs.badgeColor;

  ticket: Ticket;
  ticketInfo: TicketInfo;
  ticketService: TicketService;

  isDetail = false;
  isDealer = false;
  isDealerStaff = false;
  isDealerManager = false;
  isTicketEditable = false;
  isAdminViewerRole = false;

  company;
  isLocal = environment.isLocal;
  subscription: any = {};
  isStore;
  isAdmin;
  protected bsModalRef: BsModalRef;
  protected stepperForms = ContentSteps.CONTENT_FORMS;
  protected alive = true;


  constructor(protected authService: AuthService,
              protected apiService: ApiService,
              protected eventService: EventService,
              protected ticketManager: TicketManager,
              protected modalService: BsModalService,
              protected fb: FormBuilder,
              protected http: HttpClient,
              protected fileService: FileService,
              protected spinnerService: SpinnerService) {
    this.isDealer = this.authService.hasType(Roles.dealer);
    this.company = this.authService.getCurrentCompany();
    this.isDealerStaff = this.authService.getRolesByCompany(this.company).includes(Role.seaImDealerStaff);
    this.isDealerManager = this.authService.getRolesByCompany(this.company).includes(Role.seaImDealerSuperVisor);
    this.isAdmin = this.authService.getRolesByCompany(this.company).includes(Role.seaImAdmin);
    this.isStore = !this.authService.isHq() && !this.isAdmin;
    this.isAdminViewerRole = this.authService.checkHasAdminViewerRole();
  }

  isTabEditor() {
    this.ticket.isEdit = true;
    this.ticketManager.updateTicket = this.ticket;
  }

  setFormControlDisable(form, controls) {
    return controls.forEach(control => {
      form[control].disable();
    });
  }

  protected init(component) {
    this.subscription[component] = this.ticketManager.activeTicket$
      .pipe(takeWhile(() => this.alive))
      .subscribe(ticket => {
        if (!ticket) {
          return;
        }

        if (this.subscription[component]) {
          this.subscription[component].unsubscribe();
          return;
        }

        const { ticketInfo, ticketService } = ticket;

        this.ticket = ticket;
        this.ticketInfo = ticketInfo;
        this.ticketService = ticketService;

        this.isDetail = ticketInfo.status !== 'new';
        this.isTicketEditable = (ticketInfo.processType === Constants.processType.SR && [Constants.gcicStatus.SR_PENDING.code].includes(ticketInfo.status) ||
          ticketInfo.processType === Constants.processType.SO && Constants.gcic4kEditableStatus.includes(ticketInfo.status));
        // console.log('contents-base :::: this.isEditable =', this.isTicketEditable);
      });
  }

  protected setFormControls(component) {
    return this.fb.group(this.stepperForms[component]);
  }
}
